//#region frontend/entrypoints/sf-product.js
document.addEventListener("DOMContentLoaded", () => {
	const labels = {
		blade_length: "刃長",
		overall_length: "全長",
		weight: "重量",
		blade_material: "刀身材",
		handle_material: "ハンドル材",
		blade_finish: "刃付",
		size: "サイズ",
		material: "材質"
	};
	function updateSpecs(variantId) {
		const data = window.variantData[variantId];
		if (!data) return;
		const sku = document.getElementById("sku");
		if (sku) sku.textContent = data.sku || "";
		const tbody = document.getElementById("spec-table");
		if (!tbody) return;
		tbody.innerHTML = "";
		Object.entries(data).forEach(([key, value]) => {
			if (!value || !labels[key]) return;
			const tr = document.createElement("tr");
			const th = document.createElement("th");
			th.textContent = labels[key] ?? key;
			const td = document.createElement("td");
			td.textContent = value;
			tr.appendChild(th);
			tr.appendChild(td);
			tbody.appendChild(tr);
		});
	}
	document.addEventListener("change", (e) => {
		if (e.target.name === "id") updateSpecs(e.target.value);
	});
});
//#endregion
